import { loadTwitchCards, loadTwitchGame, loadTwitchNameIndex } from "./twitchCompact";

export const TWITCH_DAILY_HISTORY_START = "2026-02-01";

export function cleanTwitchDailyHistory(history, now = new Date()) {
  if (!(now instanceof Date) || !Number.isFinite(now.getTime())) throw new Error("Invalid Twitch history date.");
  const end = now.toISOString().slice(0, 10);
  const year = now.getUTCFullYear() - 1;
  const month = now.getUTCMonth();
  const day = Math.min(now.getUTCDate(), new Date(Date.UTC(year, month + 1, 0)).getUTCDate());
  const yearAgo = new Date(Date.UTC(year, month, day)).toISOString().slice(0, 10);
  const start = yearAgo > TWITCH_DAILY_HISTORY_START ? yearAgo : TWITCH_DAILY_HISTORY_START;
  return history.filter(point => {
    const raw = String(point?.dt || point?.date || point?.day || "").trim();
    const date = raw.slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !Number.isFinite(Date.parse(raw)) ||
        new Date(`${date}T00:00:00Z`).toISOString().slice(0, 10) !== date) {
      throw new Error("Invalid daily Twitch history timestamp.");
    }
    return date >= start && date <= end;
  });
}

export async function resolveTwitchGameId(game) {
  const explicit = game.twitchId ?? game.raw?.Twitch_ID ?? game.raw?.twitch_game_id;
  if (/^\d+$/.test(String(explicit || ""))) return String(explicit);
  const name = String(game.name || "").trim().toLowerCase();
  const index = await loadTwitchNameIndex();
  const matches = index.filter(([, title]) => String(title || "").trim().toLowerCase() === name);
  if (matches.length === 1) return matches[0][0];
  if (!matches.length) return null;
  const igdbId = game.igdbId ?? game.raw?.IGDB_ID ?? game.raw?.igdb_id;
  const release = game.release || game.raw?.Release_Date;
  const releaseTime = release ? Date.parse(release) : NaN;
  const releaseDate = Number.isFinite(releaseTime) ? new Date(releaseTime).toISOString().slice(0, 10) : null;
  if (!igdbId && !releaseDate) return null;
  const { games } = await loadTwitchCards("7d");
  const ids = new Set(matches.map(([id]) => String(id)));
  const candidates = games.filter(row => ids.has(String(row.id)));
  if (igdbId) {
    const byId = candidates.filter(row => Number(row.igdbId) === Number(igdbId));
    return byId.length === 1 ? String(byId[0].id) : null;
  }
  const byRelease = candidates.filter(row => row.releaseDate === releaseDate);
  return byRelease.length === 1 ? String(byRelease[0].id) : null;
}

export async function loadTwitchHistoryByGameId(gameId, granularity = "daily") {
  if (gameId == null || String(gameId) === "") return [];
  if (granularity !== "daily" && granularity !== "monthly") throw new Error("Unsupported Twitch history granularity.");
  const record = await loadTwitchGame(`history/${granularity}`, gameId);
  if (!record) return [];
  if (!Array.isArray(record.history)) throw new Error("Invalid per-game Twitch history.");
  return granularity === "daily" ? cleanTwitchDailyHistory(record.history) : record.history;
}